export default function BrandLogo({ size = "md", showTagline = true, className = "" }) {
  const sizes = {
    sm: { img: "h-12", tag: "text-[10px]" },
    md: { img: "h-20", tag: "text-[10px]" },
    lg: { img: "h-28", tag: "text-[11px]" },
    xl: { img: "h-32", tag: "text-xs" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex flex-col items-start ${className}`} data-testid="brand-logo">
      <img
        src="/amber-logo.png"
        alt="Amber Digital Agency"
        className={`${s.img} w-auto object-contain select-none -my-2`}
        draggable={false}
      />
      {showTagline && (
        <span className={`${s.tag} tracking-[0.32em] uppercase text-slate-400 mt-1 font-semibold`}>CRM</span>
      )}
    </div>
  );
}
